<template>
    <div>
        <div style="display: flex; height: 100%;">
            <div tabindex="1" id="audit_txts" :loading="docLoading">
                <iframe id="audit_doc" width="100%" height="100%" src="" frameborder="0"></iframe>
            </div>

            <div class="right-box">
                <div v-if="editable">
                    <h3 style="text-align: left; padding: 14px 0">审核结果：</h3>
                    <i @click="dlgMzsmVisible = true" class="el-icon-warning icons"
                        v-if="this.$root.clientType === 0">免责声明</i>
                </div>
                <div style="flex: 1; overflow-y: auto; display: flex; flex-direction: column;">
                    <el-tabs v-model="activeTabName" style="width: 100%;">
                        <el-tab-pane label="错别字" name="错别字">
                            <span slot="label">
                                <span>错别字</span>
                                <el-badge v-if="typoList.length > 0" :value="typoList.length" size="mini"
                                    class="badge-typo"></el-badge>
                            </span>
                        </el-tab-pane>
                        <el-tab-pane label="敏感词" name="敏感词">
                            <span slot="label">
                                <span>敏感词</span>
                                <el-badge v-if="senList.length > 0" :value="senList.length" size="mini"
                                    class="badge-sens"></el-badge>
                            </span>
                        </el-tab-pane>
                        <el-tab-pane label="禁用词" name="禁用词">
                            <span slot="label">
                                <span>禁用词</span>
                                <el-badge v-if="stopList.length > 0" :value="stopList.length" size="mini"
                                    class="badge-stop"></el-badge>
                            </span>
                        </el-tab-pane>
                        <el-tab-pane label="疑似错别字" name="疑似错别字">
                            <span slot="label">
                                <span> 疑似错别字</span>
                                <el-badge v-if="suspectList.length > 0" :value="suspectList.length" size="mini"
                                    class="badge-suspect"></el-badge>
                            </span>
                        </el-tab-pane>
                        <el-tab-pane label="智能识别" name="智能识别" v-if="showdpmode || dsResultList.length > 0">
                            <!-- <span slot="label">
                                <span style="font-weight: bold !important; color: orange; font-size: 16px;">智能识别</span>
                            </span> -->
                            <span slot="label">
                                <span>智能识别</span>
                                <el-badge v-if="dsResultList.length > 0" :value="dsResultList.length" size="mini"
                                    class="badge-ai"></el-badge>
                            </span>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="audit-result-table" style="flex: 1; overflow-y: auto;">
                        <div v-if="activeTabName == '智能识别'"
                            style="font-size: 18px; text-align: left; line-height: 28px; font-family: cursive !important; color: black; letter-spacing: 0;">
                            <template v-for="item in dsResultList">
                                <!-- 错误条目卡片 -->
                                <div class="error-card" @click="showSelectedWord(item)">
                                    <!-- 顶部：复选框 + 错误类型标签 -->
                                    <div class="error-card-header">
                                        <el-checkbox v-if="editable === true" v-model="item.checked" @click.native.stop class="error-checkbox" />
                                        <span class="error-type-tag"">
                                            {{ item.error_type }}
                                        </span>
                                    </div>

                                    <!-- 内容区 -->
                                    <div class=" error-card-body">
                                            <div class="error-row">
                                                <span class="error-label">错误内容</span>
                                                <span class="error-value error-text">{{ item.error_text }}</span>
                                            </div>
                                            <div class="error-row">
                                                <span class="error-label">纠正结果</span>
                                                <span class="error-value corrected-text">{{ item.corrected_text
                                                    }}</span>
                                            </div>
                                            <div class="error-row reason-row">
                                                <span class="error-label">错误原因</span>
                                                <span class="error-value reason-text">{{ item.reason }}</span>
                                            </div>
                                    </div>

                                    <!-- 操作按钮（恢复时取消注释） -->
                                    <!--
                                    <div class="error-card-actions">
                                        <el-button size="small" type="primary" plain @click.stop="aiSubmitError(item, item.error_text, item.corrected_text, item.context)">提交</el-button>
                                        <el-button size="small" @click.stop="setAiErrorStatus(item, 2)">忽略</el-button>
                                    </div>
                                    -->
                                </div>
                                <!-- <div style="display: flex; border: 2px solid red; border-radius: .3em; margin-bottom: 10px; flex: 1;">
                                    <div v-if="typeof(item) == 'object'" @click="showSelectedWord(item)"
                                        :style="{ cursor: 'pointer', textIndent: '0', padding: '3px', display: 'flex', gap: '8px', alignItems: 'flex-start' }">
                                        <el-checkbox v-model="item.checked" @click.stop style="flex-shrink: 0; margin-top: 2px;"></el-checkbox>
                                        <div style="flex: 1; border-left: 2px solid #ff8d00;">
                                            错误内容：{{ item.error_text }}<br/>
                                            纠正结果：{{ item.corrected_text }}<br/>
                                            错误类型：{{ item.error_type }}<br/>
                                            错误原因：{{ item.reason }}<br/>
                                        </div>
                                    </div>
                                    <div v-else style="flex: 1;">{{ item }}</div>
                                </div> -->
                            </template>
                        </div>
                        <table v-else style="width: 100%" class="table table-bordered table-striped text-center">
                            <thead style="background: #6fb1f7">
                                <tr>
                                    <th style="width: 20%">序号</th>
                                    <th>{{ activeTabName }}</th>
                                    <th
                                        v-if="activeTabName == '错别字' || activeTabName === '疑似错别字' || activeTabName === '智能识别'">
                                        建议修改</th>
                                    <th v-if="activeTabName == '敏感词'">敏感词类型</th>
                                    <th style="width: 20%"
                                        v-if="(activeTabName == '错别字' || activeTabName == '疑似错别字' || activeTabName === '智能识别') && editable === true">
                                        修改
                                        <el-checkbox class="tts" v-model="isCheckAllResult"
                                            @change="checkAllResult()"></el-checkbox>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in wordResultList" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td style="cursor: pointer" @click="showSelectedWord(item)">
                                        <template
                                            v-if="item.wordType == 'autoerr' || item.wordType == 'mayerr'">【样本】</template>
                                        {{ item.word }}
                                    </td>
                                    <td v-if="activeTabName == '错别字' || activeTabName == '智能识别'">
                                        <span v-show="item.trueword != ''">{{ item.trueword }}</span>
                                        <span
                                            v-show="item.trueword == ' ' && item.wordType != 'mayerr' && item.wordType != 'autoerr'">
                                            建议修改为空</span>
                                    </td>
                                    <td v-if="activeTabName === '疑似错别字'">
                                        <span>{{ item.trueword }}</span>
                                    </td>
                                    <th v-if="activeTabName == '敏感词'">{{ item.type }}</th>
                                    <th
                                        v-if="(activeTabName == '错别字' || activeTabName == '疑似错别字' || activeTabName === '智能识别') && editable === true && !item.img">
                                        <template>
                                            <el-checkbox class="tts" v-model="item.checked"
                                                @change="checkItemResult(item)">
                                                <i :class="'icon' + item.number"
                                                    style="position: absolute; right: 10px; top: 4px; color: rgb(255, 255, 255); z-index: 100; display: none;"
                                                    class="el-icon-check">
                                                </i>
                                            </el-checkbox>
                                        </template>
                                    </th>
                                </tr>
                            </tbody>

                            <div v-show="wordResultList.length <= 0"
                                style="width: 83px; margin-left: 11vw; padding: 28px 0px">
                                <img src="../assets/wsj.png" alt="" />
                                <span>暂无数据</span>
                            </div>
                        </table>
                    </div>
                </div>
                <div v-if="editable">
                    <el-button v-if="(activeTabName == '错别字' || activeTabName == '疑似错别字' || activeTabName == '智能识别')"
                        type="primary" @click="btnXiuGai()" plain>确认修改</el-button>
                    <el-button v-if="(activeTabName == '错别字' || activeTabName == '疑似错别字' || activeTabName == '智能识别')"
                        type="success" @click="btnCheHui()">撤回</el-button>
                    <!-- v-show="shows && statuss != 1" -->
                    <el-dropdown @command="exportCommand">
                        <el-button v-if="showExportBtn" type="warning" icon="el-icon-printer"
                            :loading="exportResultLoading">
                            导出
                        </el-button>

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="html">格式页面导出</el-dropdown-item>
                            <el-dropdown-item command="text">文本内容导出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>

        <div v-if="editable">
            <p v-show="auditContentLen != 0"
                style="position: absolute; text-align: right; color: #909399; width: 55%; bottom: 105px;">
                已输入{{ auditContentLen }}个字
            </p>
        </div>

        <el-dialog :visible.sync="dlgMzsmVisible" width="550px" style="text-align: left">
            <div slot="title" style="font-size: 18px" class="dialog-title">
                <i class="el-icon-warning" style="color: #ff8d00; font-size: 20px; margin-right: 6px"></i>
                <span class="title-text">免责声明</span>
                <div class="button-right">
                    <span class="title-close" @click="dlgMzsmVisible = false"></span>
                </div>
            </div>
            <div style="font-size: 16px; line-height: 25px">
                蓝太审核提供的全部审核结果均为机器审核，未经人工审核。审核结果仅供参考，无法保证结果的完全准确。北京蓝太平洋科技股份有限公司对审核结果不承担相应的法律责任。同时，也欢迎您提出宝贵建议，帮助我们不断优化审核能力。
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dlgMzsmVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import JSZipUtils from "jszip-utils"
import { saveAs } from "file-saver"
import docxtemplater from "docxtemplater"
import PizZip from "pizzip"
import { Document, Paragraph, TextRun, HeadingLevel, Packer } from 'docx'
function getFrm(frmList) {
    for (var i = 0; i < frmList.length; i++) {
        if (frmList[i].document.getElementById('audit_doc')) { return frmList[i] }
        var tmpFrm = getFrm(frmList[i].frames)
        if (tmpFrm) return tmpFrm
    }
    return null;
}
export default {
    props: {
        editable: { default: false },
        keepStyle: { default: false },
        showdpmode: { default: false },    // 是否开启了deepseek审核模式
    },
    data() {
        return {
            typoList: [],
            suspectList: [],
            stopList: [],
            senList: [],
            dsResultList: [],           // deepseek识别结果

            docLoading: false,
            exportResultLoading: false,

            isCheckAllResult: false,    // 是否选中所有错别字结果
            num: -1, // 这个需要优化下
            dlgMzsmVisible: false,
            activeTabName: '',
            auditContentLen: 0,     // 记录审核文本的字数
            contentList: [],        // 记录文本修改情况，用于撤回
            wordResultList: [],
            tableDataTypo: [],
            tableDataSuspect: [],
            tableDataStop: [],
            tableDataSen: [],
            tableDataDeepseek: []
        }
    },
    computed: {
        showExportBtn() {
            // userType: 0-管理员 1-普通用户 2-高级用户 3-VIP用户 4-测试用户
            var userType = parseInt(sessionStorage.getItem('status'))
            // 除了普通用户、测试用户，其他用户都有权限
            if (userType === 1 || userType === 4) return false
            else return true
        }
    },
    watch: {
        activeTabName(val) {
            if (val === '禁用词') this.wordResultList = this.tableDataStop
            else if (val === '疑似错别字') this.wordResultList = this.tableDataSuspect
            else if (val === '敏感词') this.wordResultList = this.tableDataSen
            else if (val === '错别字') this.wordResultList = this.tableDataTypo
            else if (val === '智能识别') this.wordResultList = this.tableDataDeepseek
            else this.wordResultList = []

            console.log(val, this.wordResultList)
        }
    },
    methods: {
        getAuditIFrame() {
            var auditFrm = null
            if (window.top.document.getElementById('audit_doc')) auditFrm = window.top;
            else auditFrm = getFrm(window.top.frames)

            // console.log('audit_doc:', auditFrm)
            return auditFrm.document.getElementById('audit_doc').contentWindow
        },
        getIframeAuditHtml() {
            return this.getAuditIFrame().document.body.innerHTML
        },
        setIframeAuditHtml(htmlStr) {
            this.getAuditIFrame().document.body.innerHTML = htmlStr
            var frameDocument = this.getAuditIFrame().document

            // 针对部分图片没有撑开p标签问题
            var nodeList = frameDocument.querySelectorAll('.MsoNormal')
            for (var i = 0; i < nodeList.length; i++) {
                nodeList[i].style['min-height'] = '17px'
            }

            // 获取文本长度
            this.auditContentLen = this.cleanAuditTxt(htmlStr).replace(/\n|\r/gi, "").length
            console.log('设置文本字数：', this.auditContentLen)
            // 设置字体大小
            frameDocument.body.style.fontSize = '22px'
            frameDocument.body.style.fontFamily = 'cursive'
        },
        onTextPaste(e) {
            console.log('粘贴内容：', e.clipboardData)
            // console.log('按键事件：', e)
            // if (e.ctrlKey && e.keyCode === 86) {
            //     console.log('用户按下了Ctrl+V')
            //     var htmlStr = this.getIframeAuditHtml()
            //     this.auditContentLen = this.cleanAuditTxt(htmlStr).replace(/\n|\r/gi, "").length
            //     console.log('设置文本字数：', this.auditContentLen)
            // }
        },
        // 封装外部调用方法
        setAuditResult(typo_list, suspect_list, stop_list, sen_list, ds_result) {
            this.wordResultList = []
            this.tableDataTypo = []
            this.tableDataSuspect = []
            this.tableDataStop = []
            this.tableDataSen = []
            this.tableDataDeepseek = []

            this.contentList = [this.getIframeAuditHtml()]
            this.activeTabName = '错别字'
            this.typoList = typo_list
            this.suspectList = suspect_list
            this.stopList = stop_list
            this.senList = sen_list
            this.dsResultList = ds_result ? ds_result : []
            this.showAuditResult()
        },
        setImageResult(typo_list, suspect_list, stop_list, sen_list) {
            for (var i = 0; i < typo_list.length; i++) {
                var item = typo_list[i]
                this.typoList.push(typo_list[i])
                this.tableDataTypo.push({
                    'number': this.tableDataTypo.length + 1,
                    'trueword': item.trueword.length === 0 ? '建议修改为空' : item.trueword,
                    'word': item.word,
                    img: true
                })
            }
            for (var i = 0; i < suspect_list.length; i++) {
                var item = suspect_list[i]
                this.suspectList.push(suspect_list[i])
                this.tableDataSuspect.push({
                    'number': this.tableDataSuspect.length + 1,
                    'word': item.word,
                    'trueword': item.trueword,
                    img: true
                })
            }
            for (var i = 0; i < stop_list.length; i++) {
                var item = stop_list[i]
                this.stopList.push(stop_list[i])
                this.tableDataStop.push({
                    word: item.word,
                    number: this.tableDataStop.length + 1,
                    img: true
                })
            }
            for (var i = 0; i < sen_list.length; i++) {
                var item = sen_list[i]
                this.senList.push(sen_list[i])
                this.tableDataSen.push({
                    'word': item.word,
                    'type': item.type,
                    'number': this.tableDataSen.length + 1,
                    img: true
                })
            }
        },
        getCleanAuditTxt() {
            // 设置的文本有好多带换行符的，直接粘贴进来有的时候并不会展示为换行，替换成<br/>显示效果会更好
            var docHtml = this.getIframeAuditHtml()

            return this.getCleanTextNew(docHtml) // this.cleanAuditTxt(docHtml)
        },
        setAuditTxt(val) {
            // 设置的文本有好多带换行符的，直接粘贴进来有的时候并不会展示为换行，替换成<br/>显示效果会更好
            val = val.replace(/\\x3c/gi, '<')   // https://www.it1352.com/341980.html
            val = val.replace(/&lt;br[ \/]*&gt;/gi, '<br/>')
            val = val.replace(/<br[^>]*>/gi, '<br/>')
            val = val.replace(/\r\n/g, ' <br/>').replace(/\n/g, '<br/>').replace(/&nbsp;/gi, ' ')
            val = val.replace(/<([^<>]*)<br[^>]*>([^<>]*)>/gi, '<$1$2>')  // 过滤属性中出现的br标签
            // 处理：<div><br/></div>会处理成两个<br/>，需要特殊处理下，替换成<br/>
            val = val.replace(/<div[^>]*><br[^<>]*><\/div>/gi, '<br/>')

            // 针对从Word复制过来的文本，或者上传的文档，获取审核文本之前需要先格式化一下
            val = val.replace(/<font face[^>]*>/gi, '')
            val = val.replace(/<style>@font-face[\s\S]*?<\/style>/gi, '')
            val = val.replace(/<!--\[if\s+gte\s+mso\s+9\]>(?:(?!<!\[endif\]-->)[\s\S])*<!\[endif\]-->/gi, '')
            val = val.replace(/&nbsp;/gi, ' ')
            this.setIframeAuditHtml(val)
            val = this.getIframeAuditHtml()
            // 设置后重新读取，然后进行以下预处理，有些东西就是设置后重新读取html，就会出现，也不知道为什么
            val = (val + '').replace(/\\x3c/gi, '<')
            val = val.replace(/<!--\[if !supportLists\]-->([\s\S]*?)<!--\[endif\]-->/gi, '$1')
            val = val.replace(/<!--[\s\S]*?-->/gi, '')
            // 处理换行
            val = val.replace(/<\/p>/gi, '</p>\n').replace(/<\/div>/gi, '</div>\n')
            val = val.replace(/<br[^>]*>/gi, '<br/>').replace(/<br\/>/gi, '<br/>\n')
            val = val.replace(/(<\/h\d+>)/gi, '$1\n')
            // 都处理完之后，再最终更新到IFrame中
            console.log('设置审核文本：', val)
            // for (var i = 0; i < 30; i++) {
            //     console.log(i, val[i])
            // }
            this.setIframeAuditHtml(val)
            this.auditContentLen = this.cleanAuditTxt(val).replace(/\n|\r/gi, "").length

            this.typoList = []
            this.suspectList = []
            this.stopList = []
            this.senList = []
            this.isCheckAllResult = false
            this.activeTabName = '错别字'
            this.wordResultList = []
            this.tableDataTypo = []
            this.tableDataSuspect = []
            this.tableDataStop = []
            this.tableDataSen = []
            this.tableDataDeepseek = []

            // console.log('设置审核文本：', val)
            // console.log('清洗后的文本：', this.cleanAuditTxt(val))
            console.log()
        },
        setAuditHtml(val) {
            val = val.replace(/<!--[\s\S]*?-->/gi, '')
            val = val.replace(/&nbsp;/gi, ' ').replace(/\n/gi, '')

            val = val.replace(/<\/p>/gi, '</p>\n').replace(/<\/div>/gi, '</div>\n')
            val = val.replace(/<br[^>]*>/gi, '<br/>').replace(/<br\/>/gi, '<br/>\n')
            val = val.replace(/(<\/h\d+>)/gi, '$1\n')

            this.setIframeAuditHtml(val)
            this.auditContentLen = this.cleanAuditTxt(val).replace(/\n|\r/gi, "").length

            this.typoList = []
            this.suspectList = []
            this.stopList = []
            this.senList = []
            this.isCheckAllResult = false
            this.activeTabName = '错别字'
            this.wordResultList = []
            this.tableDataTypo = []
            this.tableDataSuspect = []
            this.tableDataStop = []
            this.tableDataSen = []
            this.tableDataDeepseek = []
        },
        resetAuditTxt() {
            console.log(this.contentList)
            if (this.contentList.length > 0) {
                this.setIframeAuditHtml(this.contentList[0])
                this.contentList = [this.contentList[0]]
            }
            // else { this.setIframeAuditHtml('') }
        },
        // 还原到最初始状态，什么都没有，什么都是初始值
        cleanAudit() {
            this.setIframeAuditHtml('')
            this.auditContentLen = 0
            this.contentList = []
            this.typoList = []
            this.suspectList = []
            this.stopList = []
            this.senList = []
            this.dsResultList = []
            this.isCheckAllResult = false
            this.activeTabName = '错别字'
            this.wordResultList = []
            this.tableDataTypo = []
            this.tableDataSuspect = []
            this.tableDataStop = []
            this.tableDataSen = []
            this.tableDataDeepseek = []
        },
        gotoWordPos(wordid, wordPos) {
            var frameWin = this.getAuditIFrame()
            console.log(frameWin)
            // 先将位置滚动到最顶部，方便下面准确定位
            frameWin.scroll(0, 0)
            // 将页面滚动到词所在的位置
            var wordTop = frameWin.document.querySelectorAll('.' + wordid)[wordPos].offsetTop
            console.log('wordTop:', wordTop)
            frameWin.scroll(0, wordTop - 100)
        },
        showSelectedWord(val) {
            if (val.img) { console.log('图片尚不支持定位'); return; }

            console.log('定位：', val)
            var frameDocument = this.getAuditIFrame().document
            $(".log", frameDocument).remove();
            $("span", frameDocument).css("border", "none");
            if (this.activeTabName == "错别字") {
                if (val.wordid.length <= 0) return
                if (val.tipNum < 0 || val.tipNum >= val.wordid.length) { val.tipNum = 0 }
                // 显示tipNum的提示
                $("." + val.wordid[val.tipNum], frameDocument).css({
                    "border-top": "3px solid #00bcd4",
                    "border-bottom": "3px solid #00bcd4",
                    position: "relative",
                });

                $("." + val.wordid[val.tipNum], frameDocument).eq(0).css({ "border-left": "3px solid #00bcd4" });
                $("." + val.wordid[val.tipNum] + ":last", frameDocument).css({ "border-right": "3px solid #00bcd4" });
                // $("." + val.id).wrapAll("<div style='border: 3px solid #f23325;display: inline;padding: 3px 0;'></div>");
                // $("." + val.wordid[val.tipNum]).eq(0).append(
                //     '<div class="log" style="display: block;width: 200px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                //     this.activeTabName + "：" + val.word + "</li></ul></div>"
                // );
                // $(".drop-con").append(
                //     "<li class='text1'>建议修改：" + val.trueword + "</li> "
                // );
                // 跳转到定位位置
                this.gotoWordPos(val.wordid[val.tipNum], 0)
                val.tipNum += 1
                return
            } else if (this.activeTabName == "疑似错别字") {
                if (val.wordid.length <= 0) return
                if (val.tipNum < 0 || val.tipNum >= val.wordid.length) { val.tipNum = 0 }
                // 显示TipNum的提示
                $("." + val.wordid[val.tipNum], frameDocument).css({ "border-top": "3px solid #f23325", "border-bottom": "3px solid #f23325", position: "relative" });
                $("." + val.wordid[val.tipNum], frameDocument).eq(0).css({ "border-left": "3px solid #f23325" })
                $("." + val.wordid[val.tipNum] + ":last", frameDocument).css({ "border-right": "3px solid #f23325" });
                // $("." + val.wordid[val.tipNum]).eq(0)
                // .append(
                //     '<div class="log" style="display: block;width: 200px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                //     this.activeTabName + "：" + val.word + "</li></ul></div>"
                // );
                // if (val.trueword.length > 0) {
                //     $(".drop-con").append(
                //         "<li class='text1'>建议修改：" + val.trueword + "</li> "
                //     );
                // }
                // 跳转到定位位置
                this.gotoWordPos(val.wordid[val.tipNum], 0)
                val.tipNum += 1
                return
            } else {
                console.log(val)
                var nums = $("." + val.id, frameDocument).length - 1;  // 统计当前标记词个数
                this.num += 1
                if (this.num < 0 || this.num > nums) this.num = 0
                // console.log('敏感词、禁用词：', this.num, nums)
                var borderColor = '#f23325'
                if (this.activeTabName == '智能识别') borderColor = 'blue'
                if (nums >= 0) {
                    $("." + val.id, frameDocument).eq(this.num).css({ border: "3px solid " + borderColor, position: "relative" }).siblings().css("border", "none");

                    // $("." + val.id).eq(this.num).append(
                    //     '<div class="log" style="display: block;width: 200px;z-index: 10;margin-top: 3px;position: absolute; padding: 10px;color: #fff;background: #333;border-radius: 3px;box-shadow: 0 0 3px rgb(0 0 0 / 25%);"><ul class="drop-con"><li>' +
                    //     this.activeTabName + "：" + val.word + "</li></ul></div>"
                    // ).siblings().children(".log").remove();
                    // if (this.activeTabName == "敏感词") {
                    //     $(".drop-con").append(
                    //         "<li class='text1'>敏感词类型：" + val.type + "</li> "
                    //     );
                    // }
                    this.gotoWordPos(val.id, this.num)
                }
            }
        },
        cleanAuditTxt(shtml) {
            return this.getCleanTextNew(shtml)
            var curr_txt = shtml
            curr_txt = curr_txt.replace(/<\/(div)>/gi, '<br/>')
                .replace(/<\/h\d>/gi, '<br/>')
                .replace(/<\/(p)>/gi, '<br/>')
                .replace(/<br[^>]*>/gi, '\n')    // 格式化文中的br标签
                .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
                .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
                .replace(/<!--[\s\S]*?-->/gi, '')
                .replace(/<(?!br\b)\/?\w+[^>]*>/gi, '') // 其余标签全删掉

            return curr_txt
        },
        showAuditResult() {
            console.log('stop:', this.stopList)
            console.log('may:', this.suspectList)
            console.log('sens:', this.senList)
            console.log('typo:', this.typoList)
            console.log('deepseek:', this.dsResultList)

            if (this.stopList.length === 0 && this.suspectList.length === 0 && this.senList.length === 0 && this.typoList.length === 0 &&
                (!(this.dsResultList instanceof Array) || this.dsResultList.length === 0)) {
                // this.$message({ message: '恭喜你，您审核的内容通过无误！', type: 'success' })
                return
            }

            if (this.typoList.length > 0) this.activeTabName = '错别字'
            else if (this.suspectList.length > 0) this.activeTabName = '疑似错别字'
            else if (this.senList.length > 0) this.activeTabName = '敏感词'
            else if (this.stopList.length > 0) this.activeTabName = '禁用词'
            else if (this.dsResultList.length > 0) this.activeTabName = '智能识别'
            else this.activeTabName = '错别字'

            // 纯文本，用于定位敏感词、禁用词位置，因为没有返回位置
            var auditTxt = this.getCleanAuditTxt()
            // 整理出来展示结果列表
            this.tableDataStop = []
            this.stopList.forEach((item, index) => {
                var obj = {
                    id: 'stop_' + index,
                    word: item.word,
                    number: index + 1,
                    pos: []
                }
                var nStart = 0
                while (true) {
                    var npos = auditTxt.indexOf(obj.word, nStart)
                    if (npos == -1) break
                    obj.pos.push(npos)
                    nStart = npos + obj.word.length
                }
                this.tableDataStop.push(obj)
            })

            this.tableDataSuspect = []
            this.suspectList.forEach((item, index) => {
                var obj = {
                    'number': index + 1,
                    'index': item.index,
                    'word': item.word,
                    'wordType': 'wordType' in item ? item.wordType : '',
                    'trueword': item.trueword,
                    'tipNum': 0,
                    'pos': [],
                    'wordid': []
                }
                if (obj.trueword == '' && (!item.wordType || item.wordType != 'mayerr')) obj.trueword = '建议修改为空'
                else if (obj.trueword == undefined) obj.trueword = ''

                var indexArr = obj.index.toString().split(',')
                for (var i = 0; i < indexArr.length; i++) {
                    obj.pos.push(parseInt(indexArr[i]))
                    obj.wordid.push('suspect_' + indexArr[i])
                }
                this.tableDataSuspect.push(obj)
            })

            this.tableDataSen = []
            this.senList.forEach((item, index) => {
                var obj = {
                    'word': item.word,
                    'type': item.type,
                    'id': 'sen_' + index,
                    'number': index + 1,
                    pos: []
                }
                var nStart = 0
                while (true) {
                    var npos = auditTxt.indexOf(obj.word, nStart)
                    if (npos == -1) break;
                    obj.pos.push(npos)
                    nStart = npos + obj.word.length
                }
                this.tableDataSen.push(obj)
            })

            for (var i = 0; i < this.dsResultList.length; i++) {
                if (typeof (this.dsResultList[i]) != 'object') continue
                this.$set(this.dsResultList[i], 'checked', false)
                this.$set(this.dsResultList[i], 'id', 'ai_' + i)
                this.$set(this.dsResultList[i], 'number', i + 1)
                this.$set(this.dsResultList[i], 'pos', [])
                if (this.dsResultList[i].hasOwnProperty('position') && parseInt(this.dsResultList[i].position) > 0) {
                    this.dsResultList[i].pos.push(parseInt(this.dsResultList[i].position))
                } else {
                    var nstart = 0;
                    while (true && this.dsResultList[i].error_text.length > 0) {
                        var npos = auditTxt.indexOf(this.dsResultList[i].error_text, nstart)
                        if (npos == -1) break;
                        this.dsResultList[i].pos.push(npos)
                        nstart = npos + this.dsResultList[i].error_text.length
                    }
                }
            }

            this.tableDataTypo = []
            this.typoList.forEach((item, index) => {
                var typoObj = {
                    'trueword': item.trueword.length === 0 && (!('wordType' in item) || item.wordType != 'autoerr') ? '建议修改为空' : item.trueword,
                    'word': item.word,
                    'wordType': 'wordType' in item ? item.wordType : '',
                    'index': item.index.toString(),
                    'checked': false,
                    'pos': [],
                    'wordid': [],
                    'tipNum': 0,
                    'number': index + 1
                }
                var indexArr = typoObj.index.toString().split(',')
                for (let i = 0; i < indexArr.length; i++) {
                    typoObj.wordid.push('typo_' + indexArr[i])
                    typoObj.pos.push(parseInt(indexArr[i]))
                }
                this.tableDataTypo.push(typoObj)
            })
            this.wordResultList = this.tableDataTypo

            // 从这里开始，将结果标记到内容中 stopList, suspectList, senList, typoList
            // 优先展示typoList，再展示suspectList，最后才是stopList和senList，如果四个结果中存在重复词，按优先级展示
            var signList = []
            this.tableDataTypo.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    signList.push({ word: item.word, type: 'typo', color: 'red', pos: item.pos[i], id: item.wordid[i] })
                }
            })
            this.tableDataDeepseek.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    signList.push({ word: item.word, type: 'deepseek', color: '#FF1493', pos: item.pos[i], id: item.wordid[i] })
                }
            })
            this.tableDataSuspect.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    var bExist = false
                    var curr_pos = item.pos[i]
                    for (var j = 0; j < signList.length; j++) {
                        if (curr_pos >= signList[j].pos && curr_pos <= (signList[j].pos + signList[j].word.length - 1)) {
                            bExist = true; break;
                        }
                        if (signList[j].pos >= curr_pos && signList[j].pos <= (curr_pos + item.word.length - 1)) {
                            bExist = true; break;
                        }
                    }
                    if (!bExist) {
                        signList.push({ word: item.word, type: 'suspect', color: '#2196f3', pos: curr_pos, id: item.wordid[i] })
                    }
                }
            })
            this.tableDataStop.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    signList.push({ word: item.word, type: 'stop', color: '#673ab7', pos: item.pos[i], id: item.id })
                }
            })
            this.tableDataSen.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    signList.push({ word: item.word, type: 'sen', color: '#ff9800', pos: item.pos[i], id: item.id })
                }
            })
            this.dsResultList.forEach((item) => {
                for (var i = 0; i < item.pos.length; i++) {
                    signList.push({ word: item.error_text, type: 'ai', color: 'rgb(249 15 143)', pos: item.pos[i], id: item.id })
                }
            })

            var needLoading = false
            var auditHtml = this.getIframeAuditHtml()
            if (auditHtml.length > auditTxt.length * 3) needLoading = true
            console.log('html:', auditHtml.length, 'text:', auditTxt.length)

            // 开始逐个词在原文中标记
            var signLoading = null
            if (needLoading)
                signLoading = this.$loading({
                    target: '#audit_txts',
                    lock: true,
                    text: '正在标记结果...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(220, 220, 220, 0.7)'
                })
            setTimeout(async () => {
                const start = performance.now()
                console.log('开始标记')
                const gen = this.signAuditResult(signList)
                while (true) {
                    var genRes = gen.next()
                    console.log(genRes)
                    if (genRes.done) break
                }
                console.log('结束标记', `${(performance.now() - start) / 1000}s`)
                if (needLoading) signLoading.close()
            }, 1000)
        },
        * signAuditResult(signList) {
            // 对标记列表进行排序
            signList.sort((a, b) => { return a.pos - b.pos })

            var auditHtml = this.getIframeAuditHtml();
            var auditTxt = this.getCleanTextNew(auditHtml)
            var htmlPos = 0, txtPos = 0
            var i = 0
            console.log('结果总数:', signList.length)
            while (i < signList.length) {
                var item = signList[i];
                console.log('signItem:', item.pos, item.word)
                yield i++
                console.log('sign:', item);
                console.log('Text:', auditTxt.substr(item.pos, 10))
                // 判断当前位置是否存在结果
                var signWord = ''
                for (var j = item.pos; j < item.pos + item.word.length + 10 && j < auditTxt.length; j++) {
                    var tmpWord = auditTxt.substr(item.pos, j - item.pos + 1)
                    if (tmpWord.replace(/\s+/gi, '') == item.word.replace(/\s+/gi, '')) {
                        signWord = tmpWord
                        break
                    }
                }
                if (signWord.replace(/\s+/gi, '') != item.word.replace(/\s+/gi, '')) { console.log('对应位置没有找到错误'); continue }

                // 开始标记
                while (true) {
                    var nextInfo = this.goNextText(auditHtml, htmlPos, txtPos)
                    // console.log(nextInfo)
                    if (nextInfo === false) { htmlPos = false; break; }
                    // 到这里是非标签文本
                    htmlPos = nextInfo.htmlPos
                    txtPos = nextInfo.txtPos
                    if (txtPos != item.pos) {
                        if (auditHtml.substr(htmlPos, 6).toLowerCase() == '&nbsp;') {
                            htmlPos += 6
                            txtPos += 1
                        } else {
                            htmlPos += 1
                            txtPos += 1
                        }
                    } else break    // 到这里定位到开始位置
                }
                // console.log('开始位置定位结果：', htmlPos, txtPos)
                if (htmlPos === false || htmlPos === undefined) { console.log('定位失败'); break; }
                // 到这里说明定位到当前结果在HTML中的位置了
                console.log('定位到开始位置:', htmlPos)
                // 找到当前词在HTML中的结束位置
                var htmlEnd = htmlPos
                var txtEnd = txtPos
                for (var j = 1; j < signWord.length; j++) {
                    htmlEnd += 1    // 从下一个位置开始找
                    nextInfo = this.goNextText(auditHtml, htmlEnd, txtEnd)
                    if (nextInfo === false) break
                    htmlEnd = nextInfo.htmlPos
                    txtEnd = nextInfo.txtPos
                    txtEnd += 1 // 找到一个文本字符，值+1
                }
                if (txtEnd - txtPos + 1 != signWord.length || htmlEnd < htmlPos) {
                    console.log('结束位置定位失败')
                    continue
                }
                console.log('定位到结束位置:', htmlEnd, auditHtml.substr(htmlPos, htmlEnd - htmlPos + 1))
                auditHtml = this.signResultInHtml(auditHtml, htmlPos, htmlEnd, item)
                var checkNextInfo = this.goNextText(auditHtml, htmlPos, txtPos)
                if (checkNextInfo !== false) htmlPos = checkNextInfo.htmlPos
                console.log('----'); console.log('-----'); console.log('------'); console.log('-------');

                // 开始标记 signList.push({ word: item.word, type: 'typo', color: 'red', pos: item.pos[i], id: item.wordid[i] })
                // var tmpHtml = auditHtml.substr(0, htmlPos)
                // tmpHtml += ("<span class='" + item.id + "' style='background:" + item.color + ";color:white;text-indent: 0pt;'>")
                // var newHtmlPos = tmpHtml.length
                // tmpHtml += auditHtml.substr(htmlPos, htmlEnd - htmlPos + 1)
                // tmpHtml += "</span>"
                // tmpHtml += auditHtml.substr(htmlEnd+1)
                // auditHtml = tmpHtml
                // console.log('result:', auditHtml.substr(htmlPos, 200))
                // htmlPos = newHtmlPos
                // console.log(' ')
            }
            // 更新标记结果
            this.setIframeAuditHtml(auditHtml);
            return i
        },
        signResultInHtml(docHtml, htmlPos, htmlEnd, signItem) {
            // 对需要标记的文本段，如果包含标签，需要找到其中的文本，分别进行标记
            var signArea = docHtml.substr(htmlPos, htmlEnd - htmlPos + 1)
            // if(signArea.indexOf('\n') != -1) {
            //     htmlEnd += 1
            //     signArea = docHtml.substr(htmlPos, htmlEnd - htmlPos + 1)
            // }
            var areaHtmlPos = 0; var areaTextPos = 0;
            var areaArr = []
            var partSPos = 0; var partNum = 0
            while (areaHtmlPos <= signArea.length - 1) {
                console.log('area pos:', areaHtmlPos)
                var nextInfo = this.goNextText(signArea, areaHtmlPos, areaTextPos)
                console.log('next:', nextInfo)
                if (nextInfo === false) {
                    if (areaHtmlPos < signArea.length) areaArr.push(signArea.substr(areaHtmlPos))
                    break
                }
                // 判断是否是连续文本短
                if (nextInfo.htmlPos !== areaHtmlPos) {
                    // 下一个文本的位置不是当前位置，说明当前是标签
                    var partEPos = areaHtmlPos - 1
                    areaArr.push({ area: signArea.substr(partSPos, partEPos - partSPos + 1), type: 'txt' })
                    areaArr.push({ area: signArea.substr(areaHtmlPos, nextInfo.htmlPos - areaHtmlPos), type: 'tag' })
                    partSPos = nextInfo.htmlPos
                }
                areaHtmlPos = nextInfo.htmlPos; areaTextPos = nextInfo.txtPos
                if (areaHtmlPos == signArea.length - 1) {
                    areaArr.push({ area: signArea.substr(partSPos), type: 'txt' })
                }
                areaHtmlPos += 1; areaTextPos += 1;
            }
            console.log(areaArr)
            signArea = ''
            for (var areaIdx = 0; areaIdx < areaArr.length; areaIdx++) {
                if (areaArr[areaIdx].type == 'tag') signArea += areaArr[areaIdx].area
                else {
                    signArea += ("<span class='" + signItem.id + "' style='background:" + signItem.color + ";color:white;text-indent: 0pt;'>");
                    signArea += areaArr[areaIdx].area
                    signArea += "</span>"
                }
            }
            console.log('标记区域结果：', signArea)
            var tmpHtml = docHtml.substr(0, htmlPos)
            tmpHtml += signArea
            tmpHtml += docHtml.substr(htmlEnd + 1)
            return tmpHtml
        },
        goNextText(docHtml, htmlPos, txtPos) {
            // console.log('start:', htmlPos, txtPos)
            // 开始寻找下一个文本的位置
            var htmlLen = docHtml.length

            while (htmlPos < htmlLen && docHtml[htmlPos] === '<') {
                var tagEnd = -1
                if (htmlPos + 7 < htmlLen && docHtml.substr(htmlPos, 7).toLowerCase() === '<script') {
                    // var tmpStart = htmlPos
                    // while(true){
                    //     var pos = docHtml.toLowerCase().indexOf('/script>', tmpStart)
                    //     if(pos != false && docHtml[pos-1] === '<') { tagEnd = pos + 7; break }
                    //     else tmpStart = pos + 7
                    // }
                    var pos = docHtml.toLowerCase().indexOf('/script>', htmlPos)
                    if (pos != false) { tagEnd = pos + 7; }
                }
                else if (htmlPos + 6 < docHtml.length && docHtml.substr(htmlPos, 6).toLowerCase() === '<style') {
                    var pos = docHtml.toLowerCase().indexOf('/style>', htmlPos);
                    if (pos != false) { tagEnd = pos + 6; }
                }
                else if (htmlPos + 4 < docHtml.length && docHtml.substr(htmlPos, 4) === '<!--') {
                    var pos = docHtml.indexOf('-->', htmlPos);
                    if (pos != false) tagEnd = pos + 2;
                }
                else if (htmlPos + 5 < docHtml.length && docHtml.substr(htmlPos, 5).toLowerCase() === '<!doc') {
                    var pos = docHtml.indexOf('>', htmlPos);
                    if (pos != false) tagEnd = pos;
                }
                else if (htmlPos + 1 < docHtml.length && docHtml[htmlPos + 1].toLowerCase() >= 'a' && docHtml[htmlPos + 1].toLowerCase() <= 'z') {
                    var pos = docHtml.indexOf('>', htmlPos);
                    if (pos != false) tagEnd = pos;
                }
                else if (htmlPos + 2 < docHtml.length && docHtml[htmlPos + 1] === '/' && docHtml[htmlPos + 2].toLowerCase() >= 'a' && docHtml[htmlPos + 2].toLowerCase() <= 'z') {
                    var pos = docHtml.indexOf('>', htmlPos);
                    if (pos != false) tagEnd = pos;
                }
                if (tagEnd === -1) break
                // console.log('skip:', docHtml.substr(htmlPos, tagEnd - htmlPos + 1))
                // if (docHtml.substr(htmlPos, 4).toLowerCase() === '</p>') txtPos += 1
                // else if (docHtml.substr(htmlPos, 6).toLowerCase() === '</div>') txtPos += 1
                // else if (docHtml.substr(htmlPos, 3).toLowerCase() === '<br') txtPos += 1
                // else if (docHtml.substr(htmlPos, 3).toLowerCase() === '</h' && docHtml[htmlPos+3] >= '1' && docHtml[htmlPos+3] <= '9') txtPos += 1
                htmlPos = tagEnd + 1
            }
            if (htmlPos >= htmlLen) return false
            // 到这里说明定位到下一个文本位置了
            // console.log('定位文本：', htmlPos, txtPos)
            return { htmlPos, txtPos }
        },
        getCleanTextNew(html) {
            var cleanText = ''
            var htmlPos = 0; var txtPos = 0;
            while (true) {
                var nextInfo = this.goNextText(html, htmlPos, txtPos)
                if (nextInfo == false) break
                // 获取与上次定位位置之间的源码内容，判断是否有需要换行的
                // var tmpHtml = html.substr(htmlPos, nextInfo.htmlPos - htmlPos).toLowerCase()
                // if (tmpHtml.indexOf("</div>") != -1 || tmpHtml.indexOf('</p>') != -1)
                htmlPos = nextInfo.htmlPos; txtPos = nextInfo.txtPos
                cleanText += html[htmlPos]; htmlPos += 1
            }
            // console.log('纯文本：', cleanText)
            return cleanText
        },
        hideTips() {
            var frameDocument = this.getAuditIFrame().document
            $(".log", frameDocument).remove();
            $("span", frameDocument).css("border", "none");
        },
        // 错别字结果选中
        checkAllResult() {
            if (this.isCheckAllResult === true) {
                this.wordResultList.forEach((item) => {
                    $('.icon' + item.number).show()
                    item.checked = true
                })
            } else {
                this.wordResultList.forEach((item) => {
                    $('.icon' + item.number).hide()
                    item.checked = false
                })
            }
        },
        checkItemResult(val) {
            if (val.checked == true) {
                $(".icon" + val.number).show()
            } else {
                $(".icon" + val.number).hide()
                this.isCheckAllResult = false
            }
        },
        // 审核页面中需要用到的修改、撤回功能
        btnXiuGai() {
            var frameDocument = this.getAuditIFrame().document
            // 修改前，先去掉所有点击提示，避免修改后撤回导致的样式混乱
            this.hideTips()

            if (this.activeTabName === '智能识别') {
                var changeNum = 0; var preChangeText = this.getIframeAuditHtml()
                for (var i = 0; i < this.dsResultList.length; i++) {
                    if (this.dsResultList[i].checked === false) continue
                    console.log('修改：', this.dsResultList[i])
                    var elems = $("." + this.dsResultList[i].id, frameDocument)
                    elems.first().replaceWith(this.dsResultList[i].corrected_text)
                    elems.not(':first').replaceWith('')
                    changeNum += 1
                }
                if (changeNum === 0) {
                    this.$message({ message: '请勾选修改项', type: 'warning' })
                } else {
                    console.log('修改了' + changeNum + '处')
                    this.contentList.push(preChangeText)
                }
            } else {
                var changeNum = 0
                var preChangeText = this.getIframeAuditHtml()
                for (var i = 0; i < this.wordResultList.length; i++) {
                    if (this.wordResultList[i].checked === false) continue
                    for (var j = 0; j < this.wordResultList[i].wordid.length; j++) {
                        changeNum += 1
                        // $('.' + this.wordResultList[i].wordid[j]).wrapAll("<div id=" + this.wordResultList[i].wordid[j] + " style='display: inline;'></div>")
                        var elems = $("." + this.wordResultList[i].wordid[j], frameDocument)
                        elems.first().replaceWith(this.wordResultList[i].trueword);
                        elems.not(':first').replaceWith('')
                    }
                }
                if (changeNum === 0) {
                    this.$message({ message: '请勾选修改项', type: 'warning' })
                } else {
                    console.log('修改了' + changeNum + '处')
                    this.contentList.push(preChangeText)
                }
            }
        },
        btnCheHui() {
            if (this.contentList.length > 1) {
                this.setIframeAuditHtml(this.contentList.pop())
            } else {
                //
            }
        },
        convertHtmlToDocx(element) {
            const children = [];

            // 递归处理所有子节点
            for (let node of element.childNodes) {
                if (node.nodeType === Node.TEXT_NODE) {
                    if (node.textContent.trim()) {
                        children.push(new Paragraph({
                            children: [new TextRun(node.textContent)]
                        }));
                    }
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    switch (node.tagName.toLowerCase()) {
                        case 'h1':
                            children.push(new Paragraph({
                                heading: HeadingLevel.HEADING_1,
                                children: [new TextRun(node.textContent)]
                            }));
                            break;
                        case 'p':
                            children.push(new Paragraph({
                                children: [new TextRun(node.textContent)]
                            }));
                            break;
                        // 添加更多HTML标签的处理...
                        default:
                            // 递归处理子元素
                            children.push(...this.convertHtmlToDocx(node));
                    }
                }
            }

            return children;
        },
        exportCommand(command) {
            console.log('导出:', command)
            this.exportWordFile(command)
        },
        exportWordFile(exportType) {
            console.log('导出：', exportType)
            // var elem = this.getAuditIFrame().document.body
            // const children = this.convertHtmlToDocx(elem)
            // const doc = new Document({
            //     sections: [{
            //         properties: {},
            //         children: children
            //     }]
            // })
            // const blob = await Packer.toBlob(doc)
            // const url = URL.createObjectURL(blob)
            // const link = document.createElement('a')
            // link.href = url
            // link.download = '导出结果.docx'
            // link.click()
            // URL.revokeObjectURL(url)
            // return

            var shtml = this.getIframeAuditHtml()
            // 生成 appsecret
            let date = new Date()
            let year = date.getFullYear()
            let month = ('0' + (date.getMonth() + 1)).slice(-2)
            let day = ('0' + date.getDate()).slice(-2)
            var appsecret = this.$md5(sessionStorage.getItem('appkey') + (year + month + day))
            this.exportResultLoading = true
            this.$axios.post('/cmsMateService/servlet/' + (exportType == 'html' ? 'Html2Html' : 'Html2Word'), {
                content: shtml,
                appkey: sessionStorage.getItem('appkey'),
                appsecret: appsecret
            }).then(res => {
                this.exportResultLoading = false
                if (res.status != 200 || res.data.code != '200') {
                    this.$message({ message: '导出失败', type: 'warning' })
                    return
                }
                var fileLink = res.data.info
                console.log('导出文件地址：', fileLink)
                const link = document.createElement('a');
                link.href = fileLink
                link.target = '_blank'
                link.setAttribute('download', '')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }).catch(error => {
                this.exportResultLoading = false
                console.log(error)
                this.$message({ message: '导出异常', type: 'warning' })
            })
        },
        exportWord() {
            if (this.auditContentLen === 0) {
                this.$message({ message: '审核文本为空', type: 'warning' })
                return
            }
            if (this.typoList.length === 0 && this.suspectList.length === 0 && this.stopList.length === 0 && this.senList.length === 0) {
                this.$message({ message: '没有审核结果或者文本没有错误', type: 'warning' })
                return
            }
            // 处理换行
            var sText = this.getCleanAuditTxt()// this.contentList[0]
            sText = sText.replace(/<br[^>]*>/gi, '\n')
            let _this = this;
            // 读取并获得模板文件的二进制内容/web
            JSZipUtils.getBinaryContent("/static/file/index.docx", function (error, content) {
                // input.docx是模板。我们在导出的时候，会根据此模板来导出对应的数据
                // 抛出异常
                if (error) { throw error; }
                // 创建一个PizZip实例，内容为模板的内容
                let zip = new PizZip(content);
                // 创建并加载docxtemplater实例对象
                let doc = new docxtemplater(zip, { linebreaks: true });//.loadZip(zip);

                var tab1 = [];
                var tab2 = [];
                var tab3 = [];
                var tab4 = [];
                if (_this.tableDataTypo.length != 0) { tab1.push(1); }
                if (_this.tableDataSen.length != 0) { tab2.push(1); }
                if (_this.tableDataStop.length != 0) { tab3.push(1); }
                if (_this.tableDataSuspect.length != 0) { tab4.push(1); }
                console.log(tab1, tab2, tab3, tab4);
                // 设置模板变量的值
                doc.setData({
                    content: sText,
                    table: _this.tableDataTypo,
                    table2: _this.tableDataSen,
                    table3: _this.tableDataStop,
                    table4: _this.tableDataSuspect,
                    tab1: tab1,
                    tab2: tab2,
                    tab3: tab3,
                    tab4: tab4,
                })

                try {
                    // 用模板变量的值替换所有模板变量
                    doc.render();
                } catch (error) {
                    // 抛出异常
                    let e = {
                        message: error.message,
                        name: error.name,
                        stack: error.stack,
                        properties: error.properties,
                    }
                    console.log(JSON.stringify({ error: e }))
                    throw error;
                }

                // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
                let out = doc.getZip().generate({
                    type: "blob",
                    mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                })
                // 将目标文件对象保存为目标类型的文件，并命名
                saveAs(out, "检测文档.docx")
            });
        },
        checkAuditHtml() {
            var auditHtml = this.getIframeAuditHtml()
            console.log('check:', auditHtml)

            auditHtml = auditHtml.replace(/<!--[\s\S]*?-->/gi, '')
            auditHtml = auditHtml.replace(/&nbsp;/gi, ' ').replace(/\n/gi, '')
            auditHtml = auditHtml.replace(/<\/p>/gi, '</p>\n').replace(/<\/div>/gi, '</div>\n')
            auditHtml = auditHtml.replace(/<br[^>]*>/gi, '<br/>').replace(/<br\/>/gi, '<br/>\n')
            auditHtml = auditHtml.replace(/(<\/h\d+>)/gi, '$1\n')
            auditHtml = auditHtml.replace(/([^\n])<p /gi, '$1\n<p ').replace(/([^\n])<div /gi, '$1\n<div ')
            auditHtml = auditHtml.replace(/([^\n])<p>/gi, '$1\n<p>').replace(/([^\n])<div>/gi, '$1\n<div>')

            console.log('result:', auditHtml)
            this.setIframeAuditHtml(auditHtml)
            this.auditContentLen = this.cleanAuditTxt(auditHtml).replace(/\n|\r/gi, "").length
        }
    },
    mounted() {
        this.activeTabName = '错别字'

        // 让iframe可编辑
        var frameWin = this.getAuditIFrame()
        frameWin.document.designMode = 'on'
        frameWin.document.contentEditable = true
        // 兼容 FireFox, 打开并写入
        frameWin.document.open();
        frameWin.document.writeln('<html><head>');
        // frameWin.document.writeln('<style>body {background: white;font-size:9pt;margin: 2px; padding: 0px;}</style>');
        frameWin.document.writeln('</head><body></body></html>');
        frameWin.document.close();

        this.getAuditIFrame().document.addEventListener('click', () => {
            console.log('iframe点击')
            this.hideTips()

            var cleanTxt = this.getCleanAuditTxt()
            console.log(cleanTxt)
            console.log(cleanTxt.replace(/\n|\r/gi, "").length)
        })
        this.getAuditIFrame().document.addEventListener('keyup', () => {
            console.log('keyup事件')
            var auditHtml = this.getIframeAuditHtml()
            this.auditContentLen = this.cleanAuditTxt(auditHtml).replace(/\n|\r/gi, "").length
        })
        this.getAuditIFrame().document.addEventListener('paste', (e) => {
            console.log('粘贴事件：', e.clipboardData)
            setTimeout(() => {
                this.checkAuditHtml()
            }, 500);
        })
    }
}
</script>

<style lang="less">
body {
    font-size: 11px;
}

#audit_txts:empty:before {
    content: "请输入检测内容...";
    color: gray;
}

#audit_txts:focus:before {
    content: none;
}

#audit_txts {
    width: 70%;
    // height: 100%;
    // min-height: 100px;
    // overflow-y: scroll;
    letter-spacing: 1px;
    border: 1px solid #ddd !important;
    outline: none;
    text-align: left;
    font-size: 16px;
    padding: 15px;
}

.right-box {
    width: 42%;
    // position: relative;
    display: flex;
    flex-direction: column;
    // height: 100%;
    padding: 3px 14px;
    // overflow-y: scroll;
    border: 1px solid #ddd;
}

.right-box:empty:before {
    content: attr(placeholder);
    color: #bbb;
}

.right-box:focus:before {
    content: none;
}

.audit-result-table table {
    border-collapse: collapse;
    table-layout: fixed;
    border-radius: 5px;
    overflow: hidden;
    margin: 10px auto;
    /* // height: 250px; */
    font-family: cursive !important;
    color: black;
    letter-spacing: 0;
    font-size: 15px;
    /* // border: 2px solid #70aefb; */
    color: #f4f5f7;
    background-color: #328ef4;
}

.audit-result-table table td,
.audit-result-table th {
    padding: 3px;
    text-align: center;
    border: 1px solid #f5f7fa75;
    vertical-align: middle;
    font-size: 15px;
    padding: 5px;
    width: 80%;
}

.audit-result-table tbody {
    background-color: #328ef4;
}

.icons {
    font-size: 15px;
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    width: 91px;
    float: right;
    color: #2196f3;
    margin-right: 5px;
    margin-top: -35px;
}

.tts {
    width: 25px;
    height: 25px;
}

/deep/.tts .el-checkbox__inner {
    background-color: rgb(107, 107, 107);
}

.badge-typo .el-badge__content {
    background-color: red !important;
}

.badge-suspect .el-badge__content {
    background-color: #2196f3 !important;
}

.badge-stop .el-badge__content {
    background-color: #673ab7 !important;
}

.badge-sens .el-badge__content {
    background-color: #ff9800 !important;
}

.badge-ai .el-badge__content {
    background-color: rgb(249 15 143) !important;
}

.error-card {
    display: flex;
    flex-direction: column;
    background: #fafbfc;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    padding: 10px 12px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        background: #f5f7fa;
        border-color: #c0c4cc;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
}

.error-card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}

.error-checkbox {
    flex-shrink: 0;
}

.error-type-tag {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 18px;
    background: #fef0f0;
    color: #f56c6c;
}

// 不同错误类型不同颜色（可按需扩展）
.error-type-tag.grammar {
    background: #fdf6ec;
    color: #e6a23c;
}

.error-type-tag.spelling {
    background: #f0f9eb;
    color: #67c23a;
}

.error-type-tag.punctuation {
    background: #ecf5ff;
    color: #409eff;
}

.error-card-body {
    flex: 1;
    min-width: 0;
}

.error-row {
    display: flex;
    margin-bottom: 4px;
    line-height: 1.5;

    &:last-child {
        margin-bottom: 0;
    }
}

.error-label {
    flex-shrink: 0;
    width: 88px;
    color: #909399;
    font-size: 16px;
}

.error-value {
    flex: 1;
    min-width: 0;
    word-break: break-all;
    font-size: 16px;
}

.error-text {
    color: #f56c6c;
    // text-decoration: line-through;
    // text-decoration-color: rgba(245, 108, 108, 0.5);
}

.corrected-text {
    color: #67c23a;
    font-weight: 500;
}

.reason-text {
    color: #606266;
}

.error-card-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed #e4e7ed;
}
</style>



// WEBPACK FOOTER //
// src/components/DocAudit.vue